var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MegaCanvas",style:({ cursor: _vm.$store.state.hover ? 'pointer' : 'auto' })})}
var staticRenderFns = []

export { render, staticRenderFns }